import { REQUEST_FETCH_CITIES, FETCH_CITIES_SUCCESS, FETCH_CITIES_ERROR } from './actionTypes';

export const requestFetchCities = () => ({ type: REQUEST_FETCH_CITIES });

export const fetchCitiesSuccess = listOfCities => ({ type: FETCH_CITIES_SUCCESS, payload: listOfCities });

export const fetchCitiesError = () => ({ type: FETCH_CITIES_ERROR });
